import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import OperationResult from "../commons/OperationResult";
import { InsuranceApi, SiteValuesApi } from "../api/AdminApi";
import { postData } from "../api/AuthenticatedApiCaller";

export default function InsuranceAddDialog(props) {
  const [hasError, setHasError] = useState(null);

  const updatedInsurance = 
  props.insurance !== null   
  ?JSON.parse(JSON.stringify(props.insurance))
  :
  {
    title :"",
    excess:0,
    pricePerDay:0,
    defaultInsurance: false,
    "contents": createEmptyContents()
  }

  function createEmptyContents() {
		return props.languages.map((language) => {
			return {"text": "", language}
		})
	}

  async function save() {
    let [data, error] = await postData(InsuranceApi.set, updatedInsurance);
    if (!error) {
        setHasError(false)
    } else {
        setHasError(true)
    }
    props.save()
  }

  return (
    <Box>
      {hasError !== null && <OperationResult success={!hasError} />}

      {updatedInsurance !== null && (
        <Dialog open={props.open}>
          <DialogTitle>Edit Insurance{updatedInsurance.name}</DialogTitle>
          <DialogContent>
            <Stack
              sx={{ width: "100%", height: "100%" }}
              component="paper"
              spacing={4}
            >
              <TextField
                label={"Title"}
                defaultValue={updatedInsurance.title}
                onChange={(event) => {
                  updatedInsurance.title = event.target.value;
                }}
              />

              <TextField
                label={"Excess"}
                defaultValue={updatedInsurance.excess}
                onChange={(event) => {
                  updatedInsurance.excess = event.target.value;
                }}
              />

              <TextField
                label={"Price/day"}
                defaultValue={updatedInsurance.pricePerDay}
                onChange={(event) => {
                  updatedInsurance.pricePerDay = event.target.value;
                }}
              />
              {updatedInsurance.contents.map((content) => (
                <TextField
                  multiline
                  defaultValue={content.text}
                  label={"Text " + content.language}
                  onChange={(event) => {
                    content.text = event.target.value;
                  }}
                />
              ))}
            </Stack>
          </DialogContent>
          <DialogActions>
            <Button onClick={save}>Save</Button>
            <Button onClick={props.cancel} autoFocus>
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </Box>
  );
}
